(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ways-featured-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setups = new WeakMap();
  const setup = (root) => {
    if (setups.has(root)) return;
    const track = root.querySelector('[data-track]');
    const cards = Array.from(track.children);
    const controls = root.querySelector('[data-controls]');
    const footer = root.querySelector('[data-footer]');
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    const play = root.querySelector('[data-play]');
    const label = root.querySelector('[data-play-label]');
    const position = root.querySelector('[data-position]');
    const status = root.querySelector('[data-status]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = {signal:controller.signal};
    let playing = root.dataset.autoplay === 'true' && !reduced.matches && !window.Shopify?.designMode;
    let hovering = false;
    let inView = true;
    let timer;
    let scrollTimer;
    let playPointerState;
    const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const step = () => cards[0] ? cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 1;
    const update = (announce = false) => {
      const hasOverflow = max() > 4;
      controls.hidden = !hasOverflow;
      footer.hidden = !hasOverflow;
      previous.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft >= max() - 4;
      label.textContent = playing ? play.dataset.pauseLabel : play.dataset.resumeLabel;
      play.setAttribute('aria-label',label.textContent);
      const first = Math.max(1,Math.round(track.scrollLeft / step()) + 1);
      const last = Math.min(cards.length,Math.floor((track.scrollLeft + track.clientWidth + 4) / step()) + (track.clientWidth % step() > step() * .85 ? 1 : 0));
      const range = first === Math.max(first,last) ? String(first) : first + '–' + Math.max(first,last);
      position.textContent = range + ' / ' + cards.length;
      if (announce) status.textContent = status.dataset.message.replace('[range]',range).replace('[total]',String(cards.length));
    };
    const schedule = () => {
      clearTimeout(timer);
      update();
      if (!playing || hovering || !inView || document.hidden || max() < 4) return;
      timer = setTimeout(() => {
        const destination = track.scrollLeft >= max() - 4 ? 0 : Math.min(max(),track.scrollLeft + step());
        track.scrollTo({left:destination,behavior:reduced.matches ? 'instant' : 'smooth'});
        schedule();
      }, Number(root.dataset.interval) || 8000);
    };
    const stop = () => {playing = false;schedule();};
    const move = (direction) => {
      stop();
      track.scrollTo({left:Math.max(0,Math.min(max(),track.scrollLeft + step() * direction)),behavior:reduced.matches ? 'instant' : 'smooth'});
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => update(true),reduced.matches ? 0 : 450);
    };
    previous.addEventListener('click',() => move(-1),options);
    next.addEventListener('click',() => move(1),options);
    play.addEventListener('pointerdown',() => {playPointerState = playing;},options);
    play.addEventListener('click',(event) => {
      playing = !(event.detail > 0 && typeof playPointerState === 'boolean' ? playPointerState : playing);
      playPointerState = undefined;
      schedule();
    },options);
    root.addEventListener('focusin',stop,options);
    root.addEventListener('pointerenter',(event) => {if(event.pointerType === 'mouse'){hovering = true;schedule();}},options);
    root.addEventListener('pointerleave',() => {hovering = false;schedule();},options);
    track.addEventListener('pointerdown',stop,options);
    track.addEventListener('wheel',stop,{...options,passive:true});
    track.addEventListener('scroll',() => update(),{...options,passive:true});
    document.addEventListener('visibilitychange',schedule,options);
    reduced.addEventListener('change',() => {if(reduced.matches) playing = false;schedule();},options);
    const resize = new ResizeObserver(schedule);
    resize.observe(track);
    const intersection = new IntersectionObserver((entries) => {inView = entries[0].isIntersecting;schedule();},{threshold:.1});
    intersection.observe(root);
    root.addEventListener('shopify:block:select',(event) => {
      stop();
      const card = event.target.closest('.ways-featured__card');
      if(card) track.scrollTo({left:card.offsetLeft - track.offsetLeft,behavior:'instant'});
    },options);
    setups.set(root,() => {controller.abort();resize.disconnect();intersection.disconnect();clearTimeout(timer);clearTimeout(scrollTimer);});
    schedule();
  };
  document.querySelectorAll('[data-ways-featured]').forEach(setup);
  document.addEventListener('shopify:section:load',(event) => event.target.querySelectorAll('[data-ways-featured]').forEach(setup));
  document.addEventListener('shopify:section:unload',(event) => event.target.querySelectorAll('[data-ways-featured]').forEach((root) => setups.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ways-home-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const setup = (root) => {
    if(instances.has(root)) return;
    const panels = Array.from(root.querySelectorAll('[data-whs-panel]'));
    const controls = root.querySelector('[data-whs-controls]');
    const previous = root.querySelector('[data-whs-previous]');
    const next = root.querySelector('[data-whs-next]');
    const play = root.querySelector('[data-whs-play]');
    const position = root.querySelector('[data-whs-position]');
    const dots = root.querySelector('[data-whs-dots]');
    const status = root.querySelector('[data-whs-status]');
    const stage = root.querySelector('[data-whs-stage]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = {signal:controller.signal};
    let active = 0, timer, hovering = false, inView = true, pointerIntent, touch;
    let playing = root.dataset.autoplay === 'true' && !reduced.matches && !window.Shopify?.designMode;
    const selectors = panels.map((panel,index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label',dots.dataset.label.replace('[number]',String(index+1)).replace('[title]',panel.dataset.title));
      button.setAttribute('aria-controls',stage.id);
      button.addEventListener('click',() => {stop();show(index,true);},options);
      dots.append(button);
      return button;
    });
    const label = () => {play.textContent = playing ? play.dataset.pause : play.dataset.play;play.setAttribute('aria-label',play.textContent);};
    const schedule = () => {
      clearTimeout(timer);label();
      if(!playing || hovering || !inView || document.hidden || panels.length < 2) return;
      timer = setTimeout(() => {show(active+1,false);schedule();},Number(root.dataset.interval)||8000);
    };
    const stop = () => {playing = false;schedule();};
    const show = (index,announce) => {
      const target = (index + panels.length) % panels.length;
      if(target !== active && panels[active].contains(document.activeElement)) next.focus({preventScroll:true});
      active = target;
      panels.forEach((panel,i) => {panel.hidden = i !== active;panel.inert = i !== active;selectors[i].setAttribute('aria-current',String(i === active));});
      root.dataset.activeSlide = String(active+1);
      position.textContent = (active+1)+' / '+panels.length;
      if(announce) status.textContent = status.dataset.message.replace('[number]',String(active+1)).replace('[total]',String(panels.length)).replace('[title]',panels[active].dataset.title);
      if(announce && !reduced.matches) panels[active].animate([{opacity:.25},{opacity:1}],{duration:200,easing:'ease-out'});
    };
    previous.addEventListener('click',() => {stop();show(active-1,true);},options);
    next.addEventListener('click',() => {stop();show(active+1,true);},options);
    play.addEventListener('pointerdown',() => {pointerIntent = playing;},options);
    play.addEventListener('click',(event) => {playing = !(event.detail > 0 && typeof pointerIntent === 'boolean' ? pointerIntent : playing);pointerIntent = undefined;schedule();},options);
    root.addEventListener('focusin',stop,options);
    root.addEventListener('pointerenter',(event) => {if(event.pointerType==='mouse'){hovering=true;schedule();}},options);
    root.addEventListener('pointerleave',() => {hovering=false;schedule();},options);
    stage.addEventListener('touchstart',(event) => {if(event.touches.length===1){stop();touch={x:event.touches[0].clientX,y:event.touches[0].clientY};}else touch=null;},{...options,passive:true});
    stage.addEventListener('touchend',(event) => {
      if(!touch || !event.changedTouches.length) return;
      const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y;
      touch=null;
      if(Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.7) show(active+(dx<0?1:-1),true);
    },{...options,passive:true});
    stage.addEventListener('touchcancel',() => {touch=null;},{...options,passive:true});
    document.addEventListener('visibilitychange',schedule,options);
    reduced.addEventListener('change',() => {if(reduced.matches) playing=false;schedule();},options);
    const observer = new IntersectionObserver((entries) => {inView=entries[0].isIntersecting;schedule();},{threshold:.1});
    observer.observe(root);
    root.addEventListener('shopify:block:select',(event) => {const panel=event.target.closest('[data-whs-panel]');if(panel){stop();show(panels.indexOf(panel),false);}},options);
    controls.hidden = panels.length < 2;
    show(0,false);schedule();
    instances.set(root,() => {controller.abort();observer.disconnect();clearTimeout(timer);});
  };
  document.querySelectorAll('[data-whs]').forEach(setup);
  document.addEventListener('shopify:section:load',(event) => event.target.querySelectorAll('[data-whs]').forEach(setup));
  document.addEventListener('shopify:section:unload',(event) => event.target.querySelectorAll('[data-whs]').forEach((root) => instances.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
